import type { User } from '../types/config';

/** Google AdSense publisher id, e.g. ca-pub-xxxxxxxxxxxxxxxx */
export const ADSENSE_CLIENT_ID = (process.env.REACT_APP_ADSENSE_CLIENT_ID || '').trim();

/** Primary bottom banner slot (required for ads to render). */
export const ADSENSE_SLOT_PRIMARY = (process.env.REACT_APP_ADSENSE_SLOT_PRIMARY || '').trim();

/** Optional second bottom slot — leave empty for a single ad only. */
export const ADSENSE_SLOT_SECONDARY = (process.env.REACT_APP_ADSENSE_SLOT_SECONDARY || '').trim();

/**
 * Prefer non-personalized ads for school portals (safer for minors / educational traffic).
 * Set REACT_APP_ADSENSE_NPA=false to allow personalized ads after AdSense approval review.
 */
export const ADSENSE_REQUEST_NPA = process.env.REACT_APP_ADSENSE_NPA !== 'false';

export function isAdSenseConfigured(): boolean {
  return Boolean(ADSENSE_CLIENT_ID && ADSENSE_SLOT_PRIMARY);
}

/** Students / guardians only — never admin, teacher, or super_admin. */
export function canShowStudentAds(user: Pick<User, 'role'> | null | undefined): boolean {
  return user?.role === 'student';
}

export function studentAdSlots(): string[] {
  const slots = [ADSENSE_SLOT_PRIMARY, ADSENSE_SLOT_SECONDARY].filter(Boolean);
  return slots.slice(0, 2);
}
